import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Loader from '../../img/loader.gif'
import validate from './validate';
import LogoImageViewer from '../../components/logoImageViewer';
import {loginAction, getResetSecurityQuestion, checkBusinessName } from './actions/SecurityQuestionsActions';
import { renderTextField } from '../../components/reduxFields';
import GlobalVariables, { subDomainUrlRedirection } from '../../actions/utilAction';
import { LoginButton, LoginButtonDisabled } from '../../components/buttons';
import { NavLink} from 'react-router-dom';


class ResetSecurityQuestions extends Component {

  constructor(props){
    super(props);
    this.state = {
      errorMessage: null,
      token: props.match.params.token,
    }
    this.renderSecurityQuestion = this.renderSecurityQuestion.bind(this);
  }

  // componentWillMount() {
  //   let subdomain = subDomainUrlRedirection();
  //   if (subdomain) {
  //     this.props.checkBusinessName(subdomain);
  //   }
  // }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errorMessage && this.props.errorMessage !== nextProps.errorMessage) {
      let errorMessage = nextProps.errorMessage;
      this.setState({ errorMessage: errorMessage });
    }
    if (nextProps.businessNameCheck  && this.props.businessNameCheck !== nextProps.businessNameCheck) {
      let authData = {
        'SecurityQuestionToken': this.props.match.params.token,
      };
      this.props.getResetSecurityQuestion(authData, nextProps.businessNameCheck)
    }

  }

  componentDidMount() {
    let subdomain = subDomainUrlRedirection();
    if (subdomain) {
      this.props.checkBusinessName(subdomain);
    }
  }

 onSubmit = (authData) => {
    let SecurityQuestionList = [];
    if (this.props.securityQuestionList.data&& this.props.securityQuestionList.data.length) {
      this.props.securityQuestionList.data.map((obj, index) => {
        SecurityQuestionList.push({ Id: 0, QuestionID: obj.id, Answer: authData[`Question${index + 1}`] });
        return SecurityQuestionList;
      });
    }
    // console.log('this.props.authData ', this.props.authData);
    // if (this.props.authData && this.props.authData.userName && this.props.authData.password) {
     
      authData.SecurityQuestionList = SecurityQuestionList;
      authData.SecurityQuestionToken = this.state.token;
      let finalAuthData = {};
      finalAuthData.userName = null;
      finalAuthData.password = null;
      finalAuthData.SecurityQuestionList = authData.SecurityQuestionList;
      finalAuthData.ipaddress = GlobalVariables.IpAddress;
      finalAuthData.macaddress = 'ec:aa:a0:2d:dc:67';
      finalAuthData.SecurityQuestionToken = authData.SecurityQuestionToken;
      // console.log('final authdata', JSON.stringify(finalAuthData));
      this.props.loginAction(finalAuthData, this.props.businessNameCheck);
    // }
  }

  componentWillMount() {
    let subdomain = subDomainUrlRedirection();
    if (subdomain) {
      this.props.checkBusinessName(subdomain);
    }
  }

  renderSecurityQuestion() {
    this.props.securityQuestionList.data.map((ques, index) => {
      return (
        <div key = {index} className ="require">
          <Field
            name={`Question${ index + 1 }`}
            type="text"
            maxLength="30"
            label={ques.question}
            component={renderTextField} />
        </div>);
    });
  };

  ConfirmationMail = (message) => (
    <div className="login-fields text-center">
      <div className="resetmail_msg">
        <i className="material-icons">tag_faces</i>
        <div className="pt20">
          <p>{message}</p>
          {/* <p>A confimation email sent to your mail with reset password link.Thanks!</p> */}
        </div>
      </div>
      <div className="backtologin text-center"><NavLink exact to="/login"><i className="fa fa-long-arrow-left" aria-hidden="true"></i> Back to Login</NavLink></div>
    </div>
  );

  // renderForm() {
  //   const { handleSubmit } = props;
    
  // }

  
  render() {
    const { handleSubmit, authenticatingToken } = this.props;
    let logoUrl = this.props.organizationLogoBase64 && `data:image/png;base64,${this.props.organizationLogoBase64}`;

    if (!this.props.securityQuestionList) {
      return (
        <div className="login_bg">
          <div className="loaderwrap">
            <div className="loadermain">
              <img src={Loader} alt="" />
            </div>
          </div>
        </div>);
    }
    return (
      <div className="login_bg_WithGradient">
        <div className="login-wrapper">
          <div className="login-fields">
            <form className="readmin-form custom_form" noValidate onSubmit={handleSubmit(this.onSubmit.bind(this))}>
            
             <div className="loginlogo">
                <LogoImageViewer isLoginPage={true} logoUrl={logoUrl} businessName={this.props.businessName} />
              </div>
              
              {this.props.errorMessageForInvalidPass ?
                (<div style={{padding: '1.8rem' }}>

                  <div className="alert-danger">{this.props.errorMessageForInvalidPass}</div>
                  <div className='text-center'>
                    <div className="backtologin text-center"><NavLink exact to="/login"><i className="fa fa-long-arrow-left" aria-hidden="true"></i> Back to Login</NavLink></div>
                  </div>
                </div>)
                : (this.props.securityQuestionList.data && this.props.securityQuestionList.data.length ?
                  <div>
                    {this.props.securityQuestionList.data.map((ques, index) => {
                      return (
                        <div key = {index} className ="require">
                          <Field
                            name={`Question${ index + 1 }`}
                            type="text"
                            maxLength="30"
                            label={ques.question}
                            component={renderTextField} />
                        </div>);
                    })}
                    <div className="pt20">
                      {this.props.authenticating ? <LoginButtonDisabled label="Saving" /> : <LoginButton label="Save security questions" />}
                    </div>
                  </div> : 
                 '' )}
            </form>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps){
  return {
    authenticating: state.login.authenticating,
    authenticatingToken: state.login.authenticatingToken,
    authData: ownProps && ownProps.location && ownProps.location.state && ownProps.location.state.authData ? ownProps.location.state.authData : {},
    errorMessageForInvalidPass: state.security_questions.errorMessageForInvalidPass,
    businessNameCheck: state.security_questions.businessNameCheck,
    organizationLogoBase64: state.login.organizationDetails && state.login.organizationDetails.logoBase64,
    businessName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    securityQuestionList :state.security_questions.resetSecurityQuestions
  }
}

ResetSecurityQuestions = reduxForm({
  form : 'ResetSecurityQuestionsForm',
  validate,
  enableReinitialize: true,
})(ResetSecurityQuestions);

export default connect(mapStateToProps, {loginAction, getResetSecurityQuestion, checkBusinessName})(ResetSecurityQuestions);




// WEBPACK FOOTER //
// ./src/modules/SecurityQuestions/resetSecurityQuestion.js